// import React from "react";
// import styled from "styled-components";

// const Card = styled.div`
//   width: 330px;
//   height: 490px;
//   background-color: ${({ theme }) => theme.card};
//   cursor: pointer;
//   border-radius: 10px;
//   box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4);
//   overflow: hidden;
//   padding: 26px 20px;
//   display: flex;
//   flex-direction: column;
//   gap: 14px;
//   transition: all 0.5s ease-in-out;
//   &:hover {
//     transform: translateY(-10px);
//     box-shadow: 0 0 50px 4px rgba(0, 0, 0, 0.6);
//     filter: brightness(1.1);
//   }
// `;
// const Image = styled.img`
//   width: 100%;
//   height: 180px;
//   background-color: ${({ theme }) => theme.white};
//   border-radius: 10px;
//   box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.3);
// `;
// const Tags = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 8px;
//   margin-top: 4px;
// `;
// const Details = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   gap: 0px;
//   padding: 0px 2px;
// `;
// const Title = styled.div`
//   font-size: 20px;
//   font-weight: 600;
//   color: ${({ theme }) => theme.text_secondary};
//   overflow: hidden;
//   display: -webkit-box;
//   max-width: 100%;
//   -webkit-line-clamp: 2;
//   -webkit-box-orient: vertical;
//   overflow: hidden;
//   text-overflow: ellipsis;
// `;
// const Date = styled.div`
//   font-size: 12px;
//   margin-left: 2px;
//   font-weight: 400;
//   color: ${({ theme }) => theme.text_secondary + 80};
//   @media only screen and (max-width: 768px) {
//     font-size: 10px;
//   }
// `;
// const Description = styled.div`
//   font-weight: 400;
//   color: ${({ theme }) => theme.text_secondary + 99};
//   overflow: hidden;
//   margin-top: 8px;
//   display: -webkit-box;
//   max-width: 100%;
//   -webkit-line-clamp: 3;
//   -webkit-box-orient: vertical;
//   text-overflow: ellipsis;
// `;
// const Members = styled.div`
//   display: flex;
//   align-items: center;
//   padding-left: 10px;
// `;
// const Avatar = styled.img`
//   width: 38px;
//   height: 38px;
//   border-radius: 50%;
//   margin-left: -10px;
//   background-color: ${({ theme }) => theme.white};
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
//   border: 3px solid ${({ theme }) => theme.card};
// `;
// const Button = styled.a`
//   color: ${({ theme }) => theme.primary};
//   text-decoration: none;
//   font-weight: 600;
//   text-align: center;
// `;

// const ProjectCard = ({ project }) => {
//   return (
//     <Card>
//       <Image src={project.image} />
//       <Tags></Tags>
//       <Details>
//         <Title>{project.title}</Title>
//         <Date>{project.date}</Date>
//         <Description>{project.description}</Description>
//       </Details>
//       <Members>
//         {project.member?.map((member) => (
//           <Avatar src={member.img} />
//         ))}
//       </Members>
//       <Button href={project.github} target="_blank">
//         View Code
//       </Button>
//     </Card>
//   );
// };

// export default ProjectCard;




import React from "react";
import styled from "styled-components";

/* ---------- Styled Components ---------- */

const Card = styled.div`
  width: 330px;
  height: 490px;
  background-color: ${({ theme }) => theme.card};
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  padding: 26px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.4s ease-in-out;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 0 50px 4px rgba(0, 0, 0, 0.6);
    filter: brightness(1.1);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.white};
  border-radius: 10px;
  box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.3);
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Date = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary + "80"};
`;

const Description = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary + "99"};
  margin-top: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Members = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
`;

const Avatar = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  margin-left: -10px;
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border: 3px solid ${({ theme }) => theme.card};
`;

const Button = styled.a`
  margin-top: auto;
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
  text-align: center;
  text-decoration: none;
`;

/* ---------- Component ---------- */

const ProjectCard = ({ project }) => {
  const { title, date, description, image, github, member = [] } = project;

  return (
    <Card>
      <Image src={image} alt={title} />

      <Details>
        <Title>{title}</Title>
        <Date>{date}</Date>
        <Description>{description}</Description>
      </Details>

      {member.length > 0 && (
        <Members>
          {member.map((m) => (
            <Avatar key={m.img} src={m.img} alt="team member" />
          ))}
        </Members>
      )}

      {github && (
        <Button href={github} target="_blank" rel="noopener noreferrer">
          View Code
        </Button>
      )}
    </Card>
  );
};

export default ProjectCard;
